import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import {BASE_URL} from "./Constants";

const Checkout = () => {
  const navigate = useNavigate();

 useEffect(() => {
    const checkAuth = async () => {
        try {
            const res = await fetch(`${BASE_URL}/get_user_details`, {
                method: "GET",
                credentials: "include"
            });

            if (res.ok) {
              // Already logged in → go to address page
              navigate("/checkout/address");
            } else {
              // Not logged in → go to login page
              navigate("/checkout/login");
            }
        } catch (err) {
            navigate("/checkout/login")
        }
    };

    checkAuth();
  }, [navigate]);

  return null;
};

export default Checkout;


